<template>
  <v-dialog v-model="show" width="700px">
    <v-card>
      <v-card-title class="headline font-weight-bold grey lighten-2" primary-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-list v-for="(file, fileIndex) in files" :key="`csv-uploader-errors-file-${fileIndex}`">
          <v-list-item class="grey lighten-3 py-2">
            <v-list-item-avatar>
              <v-icon class="primary darken-2 white--text">note</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="file.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="(error, errorIndex) in file.errors" :key="`csv-uploader-errors-file-${fileIndex}-type-${errorIndex}`">
            <v-list-item-avatar>
              <v-icon class="red--text text--darken-3">error</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="error.name" class="red--text text--darken-2"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-2" @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CsvUploaderErrors',
  props: {
    /**
     * Errors list
     */
    files: {
      type: Array,
      required: true
    }
  },
  computed: {
    /**
     * Show errors dialog
     */
    show: {
      get () {
        return this.files.length > 0
      },
      set (show) {
        if (!show) {
          this.close()
        }
      }
    },
    /**
     * Errors dialog title
     */
    title () {
      const suffix = this.files.length > 1
        ? 's'
        : ''
      return `CSV Parsing Error${suffix}`
    }
  },
  methods: {
    /**
     * Close errors dialog
     */
    close () {
      this.$emit('close')
    }
  }
}
</script>
